module.exports = __webpack_public_path__ + "static/media/icon_notification.3767c555.svg";